module.exports = __webpack_public_path__ + "img/dahua_logo_svg.ea7f7bce.svg";